export default __webpack_public_path__ + "static/media/new_kitchen.4fb74117.png";